<app-menu-riot></app-menu-riot>
<div class="content">
    <div class="logo">
        <img src="https://playforgood.io/wp-content/uploads/2021/04/logo-legends-of-runeterra.png"
             alt="logo-legend-of-runeterra">
    </div>
    <div class="lor-info">
        <div class="container">
            <p><a href="https://playruneterra.com/fr-fr/" target="_blank">Legends of Runeterra</a> (abrégé LoR) est un jeu de cartes à
                collectionner numérique, développé et édité par <a href="https://www.riotgames.com/fr" target="_blank">Riot Games.</a>
            </p>
            <p>Le jeu, sorti le 30 avril 2020, combine des règles des jeux de cartes <a
                href="https://fr.wikipedia.org/wiki/Hearthstone" target="_blank">Hearthstone</a> et <a
                href="https://fr.wikipedia.org/wiki/Magic_:_L%27Assembl%C3%A9e_(jeu_vid%C3%A9o)" target="_blank">Magic</a>. Un système
                de
                tour par tour est mis en place, avec des actions limitées par une jauge de mana à l’instar de
                Hearthstone et
                emprunte à Magic des éléments tels que la possibilité d’intervenir durant le tour de l’adversaire et
                l’optimisation de la défense. Chaque joueur commence le match avec une main de quatre cartes à jouer
                sélectionnées au hasard dans son jeu de cartes.
            </p>
            <p>Source : <a href="https://fr.wikipedia.org/wiki/Legends_of_Runeterra" target="_blank">Wikipedia</a></p>
            <p>Les règles du tournoi LOR organisé par le Play For Good #2 : <a
                href="https://docs.google.com/document/d/1f-6ZKDZqO9a_bsTWduev2ibuTSghciGu/edit" target="_blank">ICI</a></p>
        </div>
    </div>
    <div class="widget">
        <div class="widget-content">
            <h5>Information et inscription</h5>
            <iframe width="80%" height="360" src="https://widget.toornament.com/tournaments/4559343635943694336/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Calendrier des games</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559343635943694336/matches/schedule/?_locale=fr"
                    frameborder="0"></iframe>
        </div>
        <div class="widget-content">
            <h5>Arbres du tournoi</h5>
            <iframe width="80%" height="360"
                    src="https://widget.toornament.com/tournaments/4559343635943694336/stages/4559434873400418304/?_locale=fr"
                    allowfullscreen frameborder="0"></iframe>
        </div>
    </div>
</div>


<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
